// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { Modal } from './Modal';

export interface ComingSoonModalProps {
  open: boolean;
  onClose: () => void;
  /** Optional custom title. Defaults to "Feature Coming Soon". */
  title?: string;
  /** Optional custom feature name for the message. */
  featureName?: string;
}

export function ComingSoonModal({
  open,
  onClose,
  title = 'Feature Coming Soon',
  featureName,
}: ComingSoonModalProps) {
  const message = featureName
    ? `The "${featureName}" feature is currently under development and will be available soon.`
    : 'This feature is currently under development and will be available soon.';

  return (
    <Modal open={open} onClose={onClose} size="small">
      <Modal.Header title={title} onClose={onClose} />
      <Modal.Content>
        <p style={{ margin: 0, fontSize: 16, color: '#333', lineHeight: 1.5 }}>
          {message}
        </p>
      </Modal.Content>
      <Modal.Actions>
        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: '#E0E0E0',
              border: 'none',
              borderRadius: 8,
              padding: '10px 24px',
              fontSize: 14,
              fontWeight: 500,
              color: '#333',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </Modal.Actions>
    </Modal>
  );
}
